export type FlipbookSource = {
  src: string
  thump?: string
}

export const useFlipbook = (cb?: () => void) => {
  const { getScripts } = useCdnUrl()
  const { load: loadFlipbook } = useScriptTag(
    getScripts('flipbook/flipbook.min.js'),
    undefined,
    { manual: true },
  )

  const { load: loadJquery } = useScriptTag(
    getScripts('jQuery/jquery-3.6.3.min.js'),
    undefined,
    { manual: true },
  )

  const initFlipbook = (pages: FlipbookSource[], selector: string) => {
    // @ts-ignore
    window.$(selector).flipBook({
      pages,
      icons: 'material',
      tableOfContent: {
        enabled: false,
      },
      btnPrint: {
        enabled: false,
      },
      btnSelect: {
        enabled: false,
      },
      btnThumbs: {
        enabled: false,
      },
      btnBookmark: {
        enabled: false,
      },
      btnDownloadPages: {
        enabled: false,
      },
      btnDownloadPdf: {
        enabled: false,
      },
      backgroundColor: '#ffffff',
      lightBox: true,
      startPage: 0,
    })
  }

  onMounted(async () => {
    await loadJquery()
    // @ts-ignore
    $(document).ready(async () => {
      await loadFlipbook()
      cb?.(initFlipbook)
    })
  })

  return {
    initFlipbook,
  }
}
